import { AfterViewInit, Component, ElementRef, Injector, OnDestroy, ViewChild } from '@angular/core';

// Rxjs
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

// Services
import { WebcomponentsService } from '@core/service/webcomponents.service';

// Shared
import { ONBOARDING_CARD_ENUMERATION } from '../shared';

@Component({
  selector: 'app-card-error',
  templateUrl: './card-error.component.html',
})
export class CardErrorComponent implements AfterViewInit, OnDestroy {
  @ViewChild('onboardingViews', { static: false }) public onboardingViews: ElementRef;

  private readonly unSubscribe$: Subject<void>;
  private readonly webComponentService: WebcomponentsService;

  constructor(private readonly injector: Injector) {
    this.unSubscribe$ = new Subject<void>();
    this.webComponentService = this.injector.get(WebcomponentsService);
  }

  public ngAfterViewInit(): void {
    this.renderOnboardingViews();
  }

  public ngOnDestroy(): void {
    this.unSubscribe$.next();
    this.unSubscribe$.complete();
  }

  private renderOnboardingViews(): void {
    const creditList = this.onboardingViews.nativeElement;
    this.webComponentService.isLoaded$.pipe(takeUntil(this.unSubscribe$)).subscribe({
      next: (loaded) => {
        if (loaded) {
          creditList.ngElementStrategy?.componentRef?.instance?.build({
            onboardingView: ONBOARDING_CARD_ENUMERATION.CARD_ERROR,
          });
        }
      },
    });
  }
}
